import OrderCargoOrderDetailsHandlingLogResponse, {
  OrderCargoOrderDetailsHandlingLogResponseItem,
  OrderCargoOrderDetailsHandlingLogType,
  OrderCargoOrderDetailsHandlingLogCancelResponseItem,
  OrderCargoOrderDetailsHandlingLogCPECandidatureAcceptedResponseItem,
  OrderCargoOrderDetailsHandlingLogCSOCandidatureAcceptedResponseItem,
  OrderCargoOrderDetailsHandlingLogDSOCandidatureAcceptedResponseItem,
  OrderCargoOrderDetailsHandlingLogResponseData,
} from "../../../../api/raily/order/cargo-order/handling-log/order-cargo-order-details-handling-log.response";
import OrderCargoOrderDetailsHandlingLog, {
  OrderCargoOrderDetailsHandlingLogItem,
  OrderCargoOrderDetailsHandlingLogData,
  OrderCargoOrderDetailsHandlingLogCancelItem,
  OrderCargoOrderDetailsHandlingLogAssignmentOrderNewPlanItem,
  OrderCargoOrderDetailsHandlingLogAssignmentOrderExistingPlanItem,
  OrderCargoOrderDetailsHandlingLogAssignmentOrderCancelContentItem,
} from "./order-cargo-order-details-handling-log";

const createDataHandlingLogItem = (
  item: OrderCargoOrderDetailsHandlingLogResponseItem,
): OrderCargoOrderDetailsHandlingLogItem => {
  return {
    type: OrderCargoOrderDetailsHandlingLogType.FORWARD,
    contractDisplayName: item.contract.displayName,
    author: {
      firstName: item.author.firstName,
      lastName: item.author.lastName,
    },
    createDate: item.createdAt,
  };
};

const createDataHandlingLogCancelItem = (
  item: OrderCargoOrderDetailsHandlingLogCancelResponseItem,
): OrderCargoOrderDetailsHandlingLogCancelItem => {
  return {
    type: OrderCargoOrderDetailsHandlingLogType.FORWARD_CANCEL,
    producerDisplayName: item.producer.displayName,
    consumerDisplayName: item.consumer.displayName,
    author: {
      firstName: item.author.firstName,
      lastName: item.author.lastName,
    },
    createDate: item.createdAt,
  };
};

const createDataHandlingLogCPECandidatureAcceptedItem = (
  item: OrderCargoOrderDetailsHandlingLogCPECandidatureAcceptedResponseItem,
): OrderCargoOrderDetailsHandlingLogAssignmentOrderNewPlanItem => {
  return {
    type: OrderCargoOrderDetailsHandlingLogType.ACCEPTED_CPE_CANDIDATURE,
    driverName: item.driver.displayName,
    taxiCorporationName: item.taxiCorporation.displayName,
    author: {
      firstName: item.author.firstName,
      lastName: item.author.lastName,
    },
    createDate: item.createdAt,
  };
};

const createDataHandlingLogCSOCandidatureAcceptedItem = (
  item: OrderCargoOrderDetailsHandlingLogCSOCandidatureAcceptedResponseItem,
): OrderCargoOrderDetailsHandlingLogAssignmentOrderExistingPlanItem => {
  return {
    type: OrderCargoOrderDetailsHandlingLogType.ACCEPTED_CSO_CANDIDATURE,
    driverName: item.driver.displayName,
    taxiCorporationName: item.taxiCorporation.displayName,
    author: {
      firstName: item.author.firstName,
      lastName: item.author.lastName,
    },
    createDate: item.createdAt,
    planEntryUuid: item.planEntryHumanId,
  };
};

const createDataHandlingLogDSOCandidatureAcceptedItem = (
  item: OrderCargoOrderDetailsHandlingLogDSOCandidatureAcceptedResponseItem,
): OrderCargoOrderDetailsHandlingLogAssignmentOrderCancelContentItem => {
  return {
    type: OrderCargoOrderDetailsHandlingLogType.ACCEPTED_DSO_CANDIDATURE,
    author: {
      firstName: item.author.firstName,
      lastName: item.author.lastName,
    },
    createDate: item.createdAt,
    planEntryUuid: item.planEntryHumanId,
  };
};

const createHandlingLogEvent = (
  item: OrderCargoOrderDetailsHandlingLogResponseData,
): OrderCargoOrderDetailsHandlingLogData => {
  switch (item.logType) {
    case OrderCargoOrderDetailsHandlingLogType.FORWARD:
      return createDataHandlingLogItem(
        item as OrderCargoOrderDetailsHandlingLogResponseItem,
      );
    case OrderCargoOrderDetailsHandlingLogType.FORWARD_CANCEL:
      return createDataHandlingLogCancelItem(
        item as OrderCargoOrderDetailsHandlingLogCancelResponseItem,
      );
    case OrderCargoOrderDetailsHandlingLogType.ACCEPTED_CPE_CANDIDATURE:
      return createDataHandlingLogCPECandidatureAcceptedItem(
        item as OrderCargoOrderDetailsHandlingLogCPECandidatureAcceptedResponseItem,
      );
    case OrderCargoOrderDetailsHandlingLogType.ACCEPTED_CSO_CANDIDATURE:
      return createDataHandlingLogCSOCandidatureAcceptedItem(
        item as OrderCargoOrderDetailsHandlingLogCSOCandidatureAcceptedResponseItem,
      );
    case OrderCargoOrderDetailsHandlingLogType.ACCEPTED_DSO_CANDIDATURE:
      return createDataHandlingLogDSOCandidatureAcceptedItem(
        item as OrderCargoOrderDetailsHandlingLogDSOCandidatureAcceptedResponseItem,
      );
  }
};

const createDataItem = (
  item: OrderCargoOrderDetailsHandlingLogResponseData,
): OrderCargoOrderDetailsHandlingLogData => {
  return createHandlingLogEvent(item);
};

const createData = (
  item: OrderCargoOrderDetailsHandlingLogResponseData[],
): OrderCargoOrderDetailsHandlingLogData[] => {
  return item.map(createDataItem);
};

const create = (
  item: OrderCargoOrderDetailsHandlingLogResponse,
): OrderCargoOrderDetailsHandlingLog => {
  return {
    data: createData(item.data),
  };
};

const orderCargoOrderDetailsHandlingLogFactory = {
  create,
};

export default orderCargoOrderDetailsHandlingLogFactory;
